import { render } from "./StyleEditor.vue?vue&type=template&id=0423eda5"
import script from "./StyleEditor.vue?vue&type=script&lang=js"
export * from "./StyleEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__